import React from 'react';
import { BuildingIcon, CreditCardIcon, TruckIcon, HomeIcon, WalletIcon, ZapIcon, FileTextIcon, RocketIcon } from 'lucide-react';
export function FundingTypes() {
  const fundingOptions = [{
    icon: BuildingIcon,
    title: 'SBA Loans',
    description: 'Government-backed loans with competitive rates and terms for established businesses.'
  }, {
    icon: CreditCardIcon,
    title: 'Business Lines of Credit',
    description: 'Flexible revolving credit for managing cash flow and unexpected expenses.'
  }, {
    icon: TruckIcon,
    title: 'Equipment Financing',
    description: 'Specialized funding to purchase or lease business equipment and machinery.'
  }, {
    icon: HomeIcon,
    title: 'Commercial Real Estate Loans',
    description: 'Financing solutions for purchasing or refinancing commercial property.'
  }, {
    icon: WalletIcon,
    title: 'Working Capital Loans',
    description: 'Short-term funding to cover operational expenses and business growth.'
  }, {
    icon: ZapIcon,
    title: 'Cash Advances',
    description: 'Quick funding based on future credit card sales for immediate capital needs.'
  }, {
    icon: FileTextIcon,
    title: 'Invoice Factoring',
    description: 'Convert outstanding invoices into immediate cash to improve cash flow.'
  }, {
    icon: RocketIcon,
    title: 'Startup Funding',
    description: 'Capital solutions designed specifically for new and emerging businesses.'
  }];
  return <section id="services" className="relative py-20 px-4 sm:px-6 lg:px-8 overflow-hidden bg-black" data-id="element-273">
      <div className="max-w-7xl mx-auto" data-id="element-274">
        <div className="text-center mb-16" data-id="element-275">
          <h2 className="text-4xl font-bold text-white mb-4" data-id="element-276">
            Funding Solutions for Every Business Need
          </h2>
          <p className="text-xl text-zinc-400 max-w-3xl mx-auto" data-id="element-277">
            We offer a comprehensive range of financing options tailored to
            businesses of all sizes and industries.
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-278">
          {fundingOptions.map((option, index) => <div key={index} className="bg-zinc-900/50 p-6 rounded-xl border border-zinc-800 backdrop-blur-sm hover:bg-zinc-900 transition group" data-id="element-279">
              <option.icon className="w-12 h-12 text-white mb-4 group-hover:scale-110 transition" data-id="element-280" />
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-281">
                {option.title}
              </h3>
              <p className="text-zinc-400" data-id="element-282">{option.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
}